<template>
  <b-card class="cardStyle" no-body>
    <section class="cardBody">
      <b-row class="justify-content-between text-center">
        <b-col class="d-flex align-items-center my-3" xl="auto" lg="12" md="12" sm="12" cols="12">
          <div class="detailsText" style="display: flex; align-items: center;">
            <b-icon icon="globe" scale="1.0" style="margin-right: 10px;"></b-icon>
            Study Details
          </div>
        </b-col>

        <b-col class="my-3 px-0" cols="6" xl="1" lg="1" md="2" sm="6">
          <label class="labelStyle">Protocol</label>
          <div class="siteNumberStyle">
            {{ information['studyID'] }}
          </div>
        </b-col>

        <b-col class="my-3 px-0" cols="6" xl="2" lg="2" md="2" sm="6">
          <label class="labelStyle">Status</label>
          <div id="studyStatus">
            <status :status="information['studyStatus']" />
          </div>
        </b-col>

        <b-col class="my-3" cols="6" xl="3" lg="4" md="4" sm="6">
          <label class="labelStyle" for="immediateMilestone">Immediate Next Study Milestone</label>
          <div id="immediateMilestone" class="boldInfoStyle" v-if="immediateNextMilestone">
            {{ immediateNextMilestone['title'] }}
          </div>
          <div class="boldInfoStyle" v-else>
            N/A
          </div>
        </b-col>

        <b-col class="my-3" cols="6" xl="3" lg="4" md="4" sm="6">
          <label class="labelStyle" for="nextTargetMilestone">Next Target Study Milestone</label>
          <div id="nextTargetMilestone" class="boldInfoStyle" v-if="nextTargetMilestone">
            {{ nextTargetMilestone['title'] }}
          </div>
          <div class="boldInfoStyle" v-else>
            N/A
          </div>
        </b-col>

        <b-col class="my-3" cols="1">
          <b-button variant="link" @click="toggleDetails = !toggleDetails">
            <b-img :src="toggleDetails ? arrowUpCircle : arrowDownCircle"></b-img>
          </b-button>
        </b-col>
      </b-row>

      <b-collapse id="study-details-collapse" v-model="toggleDetails">
        <b-container fluid>
          <hr class="solid" />
          <b-row class="mb-4 text-center">
            <b-col class="descriptionStyle" cols="12">{{ information['title'] }} </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b-row class="m-0 mb-2" style="background: #F2F5FF;border-radius: 15px;">
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  class="text-center text-lg-left p-0 px-4 text-nowrap"
                >
                  <p class="m-0 mt-3 textStyle">
                    <strong>Development Phase</strong>
                  </p>
                </b-col>
                <b-col
                  class="info-number-style text-center text-lg-right p-0 px-4 text-nowrap"
                  cols="12"
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  ><p class="px-2 mt-3">
                    <span style="color:#01004E"> &nbsp;{{ information['developmentPhase'] }}</span>
                  </p></b-col
                >
              </b-row>
            </b-col>

            <b-col>
              <b-row class="m-0 mb-2" style="background: #F2F5FF;border-radius: 15px;">
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  class="text-center text-lg-left p-0 px-4 text-nowrap"
                >
                  <p class="m-0 mt-3 textStyle">
                    <strong>Therapeutic Area</strong>
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  class="info-number-style text-center text-lg-right p-0 px-4 text-nowrap"
                  ><p class="px-2 mt-3">
                    <span style="color:#01004E"> &nbsp;{{ information['therapeyticArea'] }}</span>
                  </p></b-col
                >
              </b-row>
            </b-col>
          </b-row>

          <pre-stepper
            :milestones="milestones"
            :standardSteps="standardSteps"
            :milestonesTitleMap="milestonesTitleMap"
            @calculatedSteps="findImprortantMilestones($event)"
          ></pre-stepper>
        </b-container>
      </b-collapse>
    </section>
  </b-card>
</template>

<script>
  import arrowUpCircle from '../../../../images/arrowUpCircle.png';
  import arrowDownCircle from '../../../../images/arrowDownCircle.png';
  import PreStepper from './PreStepper';
  import Status from '../../common/Status';

  export default {
    name: 'StudyDetails',
    components: {
      PreStepper,
      Status,
    },
    props: {
      milestones: {
        type: Array,
        default: [],
      },
      information: {
        type: Object,
        default: {},
      },
    },
    data() {
      return {
        immediateNextMilestone: '',
        nextTargetMilestone: '',
        toggleDetails: false,
        arrowUpCircle: arrowUpCircle,
        arrowDownCircle: arrowDownCircle,
        notAvailableText: 'Not Available',
        standardSteps: [
          {
            title: 'Protocol',
            order: 1,

            status: 'Untouched',
            plannedDate: '',
            actualDate: '',
            subSteps: [],
          },
          {
            title: 'First Subject First Visit (FSFV)',
            order: 2,

            status: 'Untouched',
            plannedDate: '',
            actualDate: '',
            subSteps: [],
          },
          {
            title: 'Last Subject First Visit (LSFV)',
            order: 3,

            status: 'Untouched',
            plannedDate: '',
            actualDate: '',
            subSteps: [],
          },
          {
            title: 'Last Subject Last Visit (LSLV)',
            order: 4,

            status: 'Untouched',
            plannedDate: '',
            actualDate: '',
            subSteps: [],
          },
          {
            title: 'Database Release',
            order: 5,

            status: 'Untouched',
            plannedDate: '',
            actualDate: '',
            subSteps: [],
          },
          {
            title: 'Clinical Study Report Final',
            order: 6,

            status: 'Untouched',
            plannedDate: '',
            actualDate: '',
            subSteps: [],
          },
        ],
        milestonesTitleMap: {
          'Protocol Approved': 'Protocol Approved',
          'First Subject First Visit (FSFV)': 'First Subject First Visit (FSFV)',
          'Last Subject First Visit (LSFV)': 'Last Subject First Visit (LSFV)',
          'Last Subject Last Visit (LSLV)': 'Last Subject Last Visit (LSLV)',
          'Database Release': 'Database Release',
          'Study Report Final': 'Study Report Final',
        },
      };
    },
    methods: {
      findImprortantMilestones(steps) {
        this.immediateNextMilestone = steps.find(el => el['status'] === 'InProgress');
        let findMilestoneIndex = steps.findIndex(el => el['status'] === 'InProgress');
        if (findMilestoneIndex > 0) {
          this.nextTargetMilestone = steps[findMilestoneIndex + 1];
        }
      },
    },
  };
</script>

<style scoped>
  .detailsText {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: #0060aa;
  }
  .siteNumberStyle {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #0064c1;
  }
  .labelStyle {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }
  .boldInfoStyle {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.25px;
    color: #0064c1;
  }
  .cardBody {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 0rem 1.5rem;
  }
  .descriptionStyle {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    color: #4b4b4b;
  }
</style>
